/* NECCST PDP sticky buy bar: reveals once the main buy box scrolls out of view and
   hides again near the page end. Mirrors the live config from the buy box via the
   `neccst:variant-change` event, and its mini "Add to cart" submits the buy-box form
   (so add-to-cart behavior is identical to the main button). */
(function () {
  var bar = document.querySelector('[data-neccst-buybar]');
  var box = document.querySelector('[data-neccst-buybox]');
  if (!bar || !box) return;

  var nameEl = bar.querySelector('[data-bar-name]');
  var priceEl = bar.querySelector('[data-bar-price]');
  var finishEl = bar.querySelector('[data-bar-finish]');
  var instockEl = bar.querySelector('[data-bar-instock]');
  var addBtn = bar.querySelector('[data-bar-add]');
  var form = box.querySelector('[data-neccst-form]');

  // Mirror buy-box state into the bar.
  box.addEventListener('neccst:variant-change', function (e) {
    var d = e.detail || {};
    if (nameEl && d.title) nameEl.textContent = d.title;
    if (priceEl && d.price) priceEl.textContent = d.price;
    if (finishEl) finishEl.textContent = d.finish || '';
    if (instockEl) instockEl.textContent = d.available ? 'In stock' : 'Sold out';
    if (addBtn) {
      addBtn.disabled = !d.available;
      addBtn.innerHTML = d.available
        ? 'Add to cart <span class="arrow" aria-hidden="true">→</span>'
        : 'Sold out';
    }
  });

  // Mini add-to-cart submits the buy-box form.
  if (addBtn && form) {
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  // Visibility: show after the buy box passes, hide near the page end.
  var endEl = null;
  var sel = bar.getAttribute('data-end') || '';
  sel.split(',').some(function (s) {
    var el = document.querySelector(s.trim());
    if (el) { endEl = el; return true; }
    return false;
  });

  function sync() {
    var past = box.getBoundingClientRect().bottom < 8;
    var atEnd = false;
    if (endEl) atEnd = endEl.getBoundingClientRect().top < window.innerHeight * 0.9;
    var show = past && !atEnd;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();
